let routes = [
    // 己内酰胺
    {
        path: 'caprolactam',
        name: '己内酰胺',
        component: () => import('@/views/caprolactam/index'),
    },
    {
        path: 'caprolactam/twoPage/industry',
        name: '己内酰胺行业动态二级页',
        component: () => import('@/views/caprolactam/twoPage/industry')
    },
    {
        path: 'caprolactam/industry',
        name: '己内酰胺行业动态详情页',
        component: () => import('@/views/caprolactam/detail/industry')
    },
    {
        path: 'caprolactam/twoPage/dynamic',
        name: '己内酰胺企业动态二级页',
        component: () => import('@/views/caprolactam/twoPage/dynamic')
    },
    {
        path: 'caprolactam/dynamic',
        name: '己内酰胺企业动态详情页',
        component: () => import('@/views/caprolactam/detail/dynamic')
    },
    {
        path: 'caprolactam/twoPage/yield',
        name: '己内酰胺产量二级页',
        component: () => import('@/views/caprolactam/twoPage/yield')
    },
    {
        path: 'caprolactam/yield',
        name: '己内酰胺产量详情页',
        component: () => import('@/views/caprolactam/detail/yield')
    },
    {
        path: 'caprolactam/twoPage/downstream',
        name: '己内酰胺下游动态二级页',
        component: () => import('@/views/caprolactam/twoPage/downstream')
    },
    {
        path: 'caprolactam/downstream',
        name: '己内酰胺下游动态详情页',
        component: () => import('@/views/caprolactam/detail/downstream')
    },
    {
        path: 'caprolactam/twoPage/stock',
        name: '己内酰胺库存二级页',
        component: () => import('@/views/caprolactam/twoPage/stock')
    },
    {
        path: 'caprolactam/stock',
        name: '己内酰胺库存详情页',
        component: () => import('@/views/caprolactam/detail/stock')
    },
    {
        path: 'caprolactam/twoPage/price',
        name: '己内酰胺价格二级页',
        component: () => import('@/views/caprolactam/twoPage/price')
    },
    {
        path: 'caprolactam/price',
        name: '己内酰胺价格详情页',
        component: () => import('@/views/caprolactam/detail/price')
    },
    {
        path: 'caprolactam/backPrice',
        name: '己内酰胺后两个价格详情页',
        component: () => import('@/views/caprolactam/detail/backPrice')
    },
    {
        path: 'caprolactam/twoPage/report',
        name: '己内酰胺研究报告二级页',
        component: () => import('@/views/caprolactam/twoPage/report')
    },
    {
        path: 'caprolactam/twoPage/standard',
        name: '己内酰胺技术及标准二级页',
        component: () => import('@/views/caprolactam/twoPage/standard')
    },
    {
        path: 'caprolactam/map',
        name: '己内酰胺地图',
        component: () => import('@/views/caprolactam/detail/map.vue')
    },
    {
        path: 'caprolactam/forecast',
        name: '己内酰胺价格预测详情页',
        component: () => import('@/views/caprolactam/detail/forecast')
    },
    {
        path: 'caprolactam/twoPage/forecast',
        name: '己内酰胺价格预测二级页',
        component: () => import('@/views/caprolactam/twoPage/forecast')
    },
]

export default routes;
